'use client'

import { useEffect, useState } from 'react'

// The sale clock for client islands.
//
// First render (SSR AND the client's hydration render) returns the SERVER time
// the page was rendered with (`saleNowMs`, injected by lib/regionPageData), so
// every phase / deal-state branch is byte-identical on both sides — no #418.
// After mount it ticks every `tickMs` from the real clock, shifted by the
// preview offset (0 in production, see lib/saleCampaign getSaleClock).
export default function useSaleClock(saleNowMs, clockOffsetMs = 0, tickMs = 1000) {
  const [now, setNow] = useState(() => (Number.isFinite(saleNowMs) ? saleNowMs : 0))
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    const read = () => Date.now() + (Number(clockOffsetMs) || 0)
    setMounted(true)
    setNow(read())
    const id = setInterval(() => setNow(read()), tickMs)
    return () => clearInterval(id)
  }, [clockOffsetMs, tickMs])

  return { nowMs: now, mounted }
}
